module.exports = __webpack_public_path__ + "img/wechat_QR.9acba616.png";